<template>
  <div>
    <span class="InfoMap__action" @click="openPanel">
      <svg xmlns="http://www.w3.org/2000/svg" width="85.148" height="85.148" viewBox="0 0 85.148 85.148">
        <g id="Groupe_48060" data-name="Groupe 48060" transform="translate(-948.191 -368.081)">
          <g id="Groupe_48059" data-name="Groupe 48059" transform="translate(-1.793 -1.002)">
            <path id="Tracé_148478" data-name="Tracé 148478" d="M997.037,407.463v-3.471H985.968v6.967h4.282v20.85h6.9V407.463Z" fill="#d5a02b"/>
            <circle id="Ellipse_2099" data-name="Ellipse 2099" cx="4.751" cy="4.751" r="4.751" transform="translate(987.647 388.832)" fill="#d5a02b"/>
          </g>
          <circle id="Ellipse_2100" data-name="Ellipse 2100" cx="41.824" cy="41.824" r="41.824" transform="translate(948.941 368.831)" fill="none" stroke="#d5a02b" stroke-miterlimit="10" stroke-width="1.5"/>
        </g>
      </svg>

    </span>
    <div class="InfoMap"
         :class="isMobile ? 'InfoMap__mobile' : ''"
         v-show="show">
      <div class="InfoMap__top" @click="closePanel">
        <i class="fa fa-minus"></i>
      </div>
      <div class="InfoMap__body">
        <template v-if="spaces && space.panel_info" v-for="space in spaces">
          <h4 class="InfoMap__body-title">{{ space.title }}</h4>
          <ul class="InfoMap__items">
              <li v-for="item in space.items"
                  @mouseover="changeHoveredItem(item.slug)"
                  @mouseleave="changeHoveredItem(null)"
                  :class="`InfoMap__item ${item.info_additional ? `InfoMap__item-flex` : ``}`">
                <a :href="item.url">
                  <span><strong>{{ `${item.title_info}` }}</strong></span>
                  <span v-if="item.info_additional" v-html="item.info_additional"></span>
                </a>
              </li>
          </ul>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoMap',
  props: {
    spaces: {
      type: Array,
      required: false
    },
    showInfoPanel: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return ({
      show: this.$props?.showInfoPanel,
      isMobile: this.$props?.mobile
    })
  },
  methods: {
    openPanel() {
      this.show = true;
      this.$emit('closeCard')
    },
    closePanel() {
      this.show = false;
    },
    changeHoveredItem(slug) {
      this.$emit('spaceHoveredChange', {slug, type:'hover', area: this.$enums.Spaces.INFO})
    }
  }
}
</script>